import { RootState } from 'app/store/rootReducer';

export const selectShouldCheckIfConsentResetRequired = (state: RootState) =>
  state.consents.shouldCheckIfConsentResetRequired;
